/* Copyright (c) 2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

/** query-string may parse a single query param as a string instead of string[]. */
export const coerceToStringArray = (
  value: string | readonly string[] | null | undefined
): string[] => {
  if (value == null) {
    return [];
  }

  if (typeof value === "string") {
    return [value];
  }

  return [...value];
};

export const getCountBasedDisplayValue = (
  values: string[],
  isExcluded: boolean | undefined,
  labels: { singular: string; plural: string }
) => {
  if (!values.length) {
    return "";
  }

  if (values.length === 1) {
    return isExcluded ? `Exclude: ${values[0]}` : values[0];
  }

  const label = labels.plural;
  return isExcluded
    ? `Exclude: ${values.length} ${label}`
    : `${values.length} ${label}`;
};

export const removeSelectedValue = <TValue extends string>(
  values: TValue[] | undefined,
  valueToRemove: string
) => (values ?? []).filter((value) => value !== valueToRemove);

export const createValueLabelMap = <TItem>(
  items: TItem[],
  getValue: (item: TItem) => string,
  getLabel: (item: TItem) => string
) =>
  items.reduce<Record<string, string>>(
    (accumulator, item) => ({
      ...accumulator,
      [getValue(item)]: getLabel(item),
    }),
    {}
  );
